export default "__VITE_ASSET__CuVGroBf__"